import { render, staticRenderFns } from "./RegisterAdjustmentDataRow.vue?vue&type=template&id=56c687da&scoped=true&"
import script from "./RegisterAdjustmentDataRow.vue?vue&type=script&lang=ts&"
export * from "./RegisterAdjustmentDataRow.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterAdjustmentDataRow.vue?vue&type=style&index=0&id=56c687da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c687da",
  null
  
)

export default component.exports